module.exports = __webpack_public_path__ + "img/28.c8478c3a.jpg";